import {
  EARLY_ACCESS_TO_NEW_IN,
  LOYALTY_ENABLED_COUNTRIES
} from "../../state/modules/category/constants";

const shouldShowNewInTodayRibbon = ({ browseCountry, loyaltyBenefitType }) =>
  LOYALTY_ENABLED_COUNTRIES.includes(browseCountry) &&
  loyaltyBenefitType === EARLY_ACCESS_TO_NEW_IN;

export default shouldShowNewInTodayRibbon;
